import { ActionMessage, TypeMessage } from './../../entity/enum/enum-notification';
import { NotificationService } from './../../services/notification.service';
import { FormularioService } from './../../services/formulario.service';
import { environment } from 'src/environments/environment';
import { Router } from '@angular/router';
import { Component, OnInit, OnChanges, SimpleChanges } from '@angular/core';
import { GeneralService } from 'src/app/services/general.service';
import { HttpClient, HttpHeaders } from '@angular/common/http';

@Component({
    selector: 'app-top-menu',
    templateUrl: './top-menu.component.html',
    styleUrls: ['./top-menu.component.scss']
})
export class TopMenuComponent implements OnInit, OnChanges {

    public changeArrow?: boolean;
    public title?: string;
    public userName?: string;
    public isDev?: boolean;
    public connectionStatus: boolean;
    public uploadPc0003:boolean = false;

    // tslint:disable-next-line: max-line-length
    constructor(
        protected route: Router, 
        protected generalService: GeneralService, 
        protected formularioService: FormularioService, 
        protected notificationService: NotificationService, 
        protected http: HttpClient,
    ) {
        this.changeArrow = false;
        this.isDev = environment.refreshToken;
    }

    async ngOnChanges(changes: SimpleChanges): Promise<void> {
        await this.generalService.getValue().subscribe(response => {
            this.title = response;
        });
        await this.generalService.getUserNameValue().subscribe(async (response) => {
            this.userName = response;
        });

    }

    async ngOnInit(): Promise<void> {
        await this.generalService.getValue().subscribe(response => {
            this.title = response;
        });
        await this.generalService.getUserNameValue().subscribe(async (response) => {
            this.userName = response;
        });
        setInterval(async () => await this.getConnectionStatus(), 5000);

        this.getAccessUpload(this.userName);

    }

    getAccessUpload(userName){
        this.generalService.getAccessUpload(userName).subscribe( 
            response => this.uploadPc0003 = response.user_name
        )
    }

    goToRoute(rota, titulo): void {
        this.generalService.setValue(titulo);
        this.generalService.goToRoute(rota);
    }

    async refreshToken(): Promise<void> {
        if (environment.refreshToken) {
            const token: string = '';
            await this.setCookie('frontend-app', token, 24).then(response => {
                this.notificationService.sendNotification('', TypeMessage.Token, ActionMessage.Success);
                location.reload();
            }).catch(responseError => {
                this.notificationService.sendNotification('', TypeMessage.TokenError, ActionMessage.Error);
            })
        }
    }

    private async setCookie(cookieName: string, token: string, expired: number) {
        var d = new Date();
        d.setTime(d.getTime() + (expired * 60 * 1000));
        var expires = "expires=" + d.toUTCString();
        document.cookie = cookieName + "=" + token + ";" + expires + ";path=/";
    }

    private async getConnectionStatus(): Promise<void> {
        if (localStorage.getItem('statusNetwork')) {
            let isOnline = JSON.parse(localStorage.getItem('statusNetwork'));
            this.connectionStatus = isOnline;
        } else {
            this.connectionStatus = true;
        }
    }
}
